export default __webpack_public_path__ + "static/media/hedef-500bin_5_copy_2-01.09e41bbe.svg";